import Created from './Created';
import Name from './Name';
import Email from './Email';
import Updated from './Updated';
import IsCustomerContact from './IsCustomerContact';
import IsSupplierContact from './IsSupplierContact';
import Mobile from './Mobile';
import Position from './Position';
import Username from './Username';
import WebshopAccess from './WebshopAccess';
import Website from './Website';

export const labels = {
  Name: 'Név',
  Email: 'E-mail',
  IsCustomerContact: 'Vevői',
  IsSupplierContact: 'Beszállítói',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  Mobile: 'Mobil',
  Position: 'Beosztás',
  Username: 'Felhasználónév',
  WebshopAccess: 'Webshop',
  Website: 'Honlap',
};

export const allColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'Email',
}, {
  value: 'IsCustomerContact',
}, {
  value: 'IsSupplierContact',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Mobile',
}, {
  value: 'Position',
}, {
  value: 'Username',
}, {
  value: 'WebshopAccess',
}, {
  value: 'Website',
},];

export const defaultColumns = [{
  value: 'Name',
  fixed: true,
}, {
  value: 'Email',
}, {
  value: 'IsCustomerContact',
}, {
  value: 'IsSupplierContact',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Created,
  Updated,
  Name,
  Email,
  IsCustomerContact,
  IsSupplierContact,
  Mobile,
  Username,
  Position,
  WebshopAccess,
  Website,
};
